import angular from 'angular';

angular.module('core', []).config(function() {});